import axios from 'axios'

export default {
    getCountries() {
        return axios.get('/api/countries/lookup');
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/addressselector/api.js